import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=73513dc9&scoped=true&lang=pug&"
import script from "./TermsContent.vue?vue&type=script&lang=js&"
export * from "./TermsContent.vue?vue&type=script&lang=js&"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=73513dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73513dc9",
  null
  
)

export default component.exports